<template>
  <vx-card no-shadow>

    <div class="vx-row mb-5">
      <div class="vx-col w-full">

        <!--Class with one line and two columns-->
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">

            <label class="text-sm font-bold">Formato da pontuação</label>
            <div class="mt-2">
              <label ><input type="radio" v-model="scoringFormat" value="number"> &nbsp;Número</label>
              <label> &nbsp;&nbsp;&nbsp;<input type="radio" v-model="scoringFormat" value="percent"> &nbsp;Percentagem</label>
            </div>
            <span class="text-danger text-sm" v-show="errors.has('pontuacao')">{{ errors.first('pontuacao') }}</span>
          </div>

          <div class="vx-col sm:w-1/2 w-full mb-2">

            <label class="text-sm font-bold">Atraso baseado no fingerprint</label>
            <div class="mt-2">
              <label><input type="radio" v-model="fingerPrint" :value="true"> &nbsp;Sim</label>
              <label>&nbsp;&nbsp;&nbsp;<input type="radio" v-model="fingerPrint" :value="false"> &nbsp;Não</label>
            </div>
            <span class="text-danger text-sm" v-show="errors.has('fingerprint')">{{ errors.first('fingerprint') }}</span>
          </div>
        </div>
        
        <div v-if="fingerPrint == true" class="vx-row mt-3">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label class="text-sm font-bold">Horário de Entrada </label>
            <div class="mt-2">
              <label><input type="radio" v-model="delay" :value="true"> &nbsp;Sim</label>
              <label>&nbsp;&nbsp;&nbsp;<input type="radio" v-model="delay" :value="false"> &nbsp;Não</label>
            </div>
            <span class="text-danger text-sm" v-show="errors.has('atraso')">{{ errors.first('atraso') }}</span>
          </div>

          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label class="text-sm font-bold">Horário de Saída</label>
            <div class="mt-2">
              <label><input type="radio" v-model="early" :value="true"> &nbsp;Sim</label>
              <label>&nbsp;&nbsp;&nbsp;<input type="radio" v-model="early" :value="false"> &nbsp;Não</label>
            </div>
            <span class="text-danger text-sm" v-show="errors.has('saida')">{{ errors.first('saida') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap items-center justify-end">

      <vs-button class="ml-auto mt-2" @click="saveData()">Salvar</vs-button>

    </div>
  </vx-card>
</template>

<script>
import http from "../../../../http-common";
import { PermissionsMixin } from "../../../mixins/permissions";
export default {
  mixins: [PermissionsMixin],
  data() {
    return {
      scoringFormat: "percent",
      fingerPrint: false,
      delay: false,
      early: false,
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },

  },

  mounted() {

  },


  methods: {

    async saveData() {
      this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      const data = {
        scoring_format: this.scoringFormat,
        is_attendance_based_on_finger_print: this.fingerPrint,
        is_attendance_based_on_delay: this.delay,
        is_attendance_based_on_early: this.early

      };

      this.$validator.validateAll();
      await http
        .post("/performances/settings", data, config)
        .then((success) => {
          success;

          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Salvo com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.$vs.loading.close();
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }
          if (error.response.status == 422) {
            this.err = error.response.data
            console.log(this.err)
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-right",
            })
          } else {
            this.$vs.notify({
              title: "Erro",
              text: "Aconteceu algum erro",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          }
        });
      },
    },
  }
</script>
